module.exports = __webpack_public_path__ + "assets/img/wx_scan.52ecad42.png";